import { IApplicationState } from '../../types/redux';
import { TUserAnalytics } from '../../types/analytics';

export const getUser = (state: IApplicationState): TUserAnalytics => {
  if (!state.user) {
    return {
      type: 'not_authorized',
    };
  }

  return {
    cianUserId: state.user.cianUserId,
    email: state.user.email || '',
    type: state.userRole || null,
    userId: state.user.realtyUserId,
  };
};
